export default Vue.extend({
  props: {
    organizationId: {
      type: Number,
      required: true
    },
    pendingOrganizationApplicationsCount: {
      type: Number,
      default: 0
    },
    activeTab: {
      type: String,
      default: 'info'
    }
  },

  computed: {
    url() {
      return `/admin/organizations/${this.organizationId}/`
    },

    organizationApplicationsText() {
      if (this.pendingOrganizationApplicationsCount === 0) return '申请列表'
      return `申请列表（${this.pendingOrganizationApplicationsCount}）`
    }
  },

  methods: {
    tabClass(tab) {
      return {
        'nav-item': true,
        active: tab === this.activeTab
      }
    }
  },

  template: `
    <div class="organization-tab tabs">
      <div class="tab-navs reverse nav">
        <a :href='url + "members"' :class="tabClass('members')">组织成员</a>
        <a :href='url + "organization_applications"' :class="tabClass('organization_applications')">{{ organizationApplicationsText }}</a>
        <a :href='url' :class="tabClass('info')">组织信息</a>
        <a :href='url + "administrators"' :class="tabClass('administrators')">组织管理员</a>
        <a :href='url + "namecards"' :class="tabClass('namecards')">组织名片</a>
      </div>
    </div>
  `
})
